import { currentOrganisation } from '@/api';

export const currentOrganisationMixin = {
  data() {
    return {
      currentOrganisation,
    };
  },
  computed: {
    currentOrganisationQuota() {
      return this.currentOrganisation.quota;
    },
  },
};
